$('.hpe-account-table__header').click(function () {
  const activeClass = 'hpe-account-table__header--active';
  const thisElement = $(this);

  thisElement
    .addClass(activeClass)
    .siblings()
    .removeClass(activeClass);

  if (thisElement.hasClass(activeClass)) {
    thisElement
      .children('.hpe-account-table__sort')
      .toggleClass('hpe-account-table__sort--reverse');
  }
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/table-sort.js